<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content" v-if="busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else class="content">
            <div class="card">
                <div class="card-header">
                    <h6 class="card-title font-weight-semibold">Födelsedagar denna vecka</h6>
                </div>
                <table class="table" v-if="birthdays.birthdays_this_week && Object.keys(birthdays.birthdays_this_week).length > 0">
                    <tr>
                        <th>Namn</th>
                        <th>Födelsedatum</th>
                        <th>Fyller</th>
                    </tr>
                    <tr v-for="(user, utw_index) in birthdays.birthdays_this_week" :key="'bday-tw-' + utw_index">
                        <td>{{ user.FullName }}</td>
                        <td>{{ user.BirthDate }}</td>
                        <td>{{ user.NewAge }}</td>
                    </tr>
                </table>
                <div class="card-body" v-else>
                    <i>Inga födelsedagar denna vecka</i>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <h6 class="card-title font-weight-semibold">Födelsedagar nästa vecka</h6>
                </div>
                <table class="table" v-if="birthdays.birthdays_next_week && Object.keys(birthdays.birthdays_next_week).length > 0">
                    <tr>
                        <th>Namn</th>
                        <th>Födelsedatum</th>
                        <th>Fyller</th>
                    </tr>
                    <tr v-for="(user, unw_index) in birthdays.birthdays_next_week" :key="'bday-nw-' + unw_index">
                        <td>{{ user.FullName }}</td>
                        <td>{{ user.BirthDate }}</td>
                        <td>{{ user.NewAge }}</td>
                    </tr>
                </table>
                <div class="card-body" v-else>
                    <i>Inga födelsedagar nästa vecka</i>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';

export default {
    name: 'Birthdays',
    components: {
        LimitlessPageHeader,
    },
    data: () => ({
        busy_loading: true,
        birthdays: null,
    }),
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.busy_loading = true;
            apiClient.get('/vue/users/birthdays')
                .then((response) => {
                    this.birthdays = response.data;
                }).finally(() => {
                    this.busy_loading = false;
                });
        },
    },
};

</script>
